<template>
  <q-dialog
    ref="dialogRef"
    full-height
    full-width
    :maximized="isMaximized"
    v-bind="innerDialogProps"
    v-on="dialogListeners"
  >
    <q-card class="column full-height">
      <dialog-header @close="onCloseDialog" :title="headerTitle" class="col-auto" />
      <div style="height: 100%" class="col">
        <img
          v-show="false"
          @vue:mounted="setViewer"
          id="image"
          :src="image"
          style="width: 100%; max-height: 100%"
        />
      </div>
    </q-card>
  </q-dialog>
</template>

<script>
import { defineComponent, computed } from 'vue'
import { useDialogPluginComponent, useQuasar } from 'quasar'
import { useDialog } from 'src/composables/dialog'

export default defineComponent({
  name: 'ImageVisualizerDialog'
})
</script>

<script setup>
import Viewer from 'viewerjs'
import 'viewerjs/dist/viewer.css'

const props = defineProps({
  image: [String, File],
  maximized: Boolean,
  filename: String
})

/* const emit = */ defineEmits([...useDialogPluginComponent.emits])

const { dialogRef, onDialogHide, onDialogOK: onOKClick, onDialogCancel: onCancelClick } = useDialogPluginComponent()

const { dialogProps, dialogListeners, onCloseDialog } = useDialog({ onDialogHide, onCancelClick, onOKClick })

const $q = useQuasar()

const headerTitle = computed(() => props.filename || 'Visualizar Imagem')

const isMaximized = computed(() => props.maximized || $q.screen.lt.md)

const innerDialogProps = computed(() => {
  return {
    ...dialogProps,
    ...($q.screen.lt.md && {
      position: undefined,
      transitionShow: 'slide-up',
      transitionHide: 'slide-down'
    })
  }
})

// View an image.
const setViewer = () => {
  // eslint-disable-next-line no-new
  new Viewer(document.getElementById('image'), {
    inline: true,
    navbar: false,
    title: false,
    backdrop: false,
    button: false,
    toolbar: {
      zoomIn: true,
      zoomOut: true,
      rotateLeft: true,
      rotateRight: true,
      flipHorizontal: true,
      flipVertical: true,
      reset: true
    },
    zoomRatio: 0.3
  })
}

</script>
